export default function Faq() {
  return (
    <>
      <h3>FAQs</h3>
      <div className="today-faqs fundamental-list">
        <h3>What is Fundamental Analysis?</h3>

        <p>
          Fundamental analysis is a method of evaluating the value of a stock by
          examining the financial performance, business strategy, competitive
          position, and growth prospects of the company that issues it.
          Fundamental analysis also considers the macroeconomic and industry
          factors that affect the demand and supply of the stock in the market.
          Fundamental analysis parameters like Sales/ Revenue, Market
          capitalization, PE ratio, Dividend yield, Net profit margin (NPM),
          Operating profit margin (OPM), Return on equity (ROE), Earnings per
          share (EPS), Gross profit margin (GPM), debt to equity ratio (D/E)
          etc.
        </p>

        <p>
          In a nutshell, fundamental analysis is to find intrinsic value of a
          stock.
        </p>

        <h3>What are the 3 layers of fundamental analysis?</h3>

        <p>Fundamental analysis consists of three main parts:</p>

        <ul>
          <li>Economic Analysis</li>

          <li>Industry Analysis</li>

          <li>Company Analysis</li>
        </ul>

        <h3>What is Economic Analysis in fundamental analysis of a stock?</h3>

        <p>
          Economic analysis: This involves analyzing the overall economic
          environment to identify the impact of macroeconomic factors on the
          company's performance.
        </p>

        <p>
          A macroeconomic factor is a phenomenon, pattern, or condition that
          emanates from, or relates to, a large aspect of an economy rather than
          to a particular population. Inflation, gross domestic product (GDP),
          national income, and unemployment levels are examples of macroeconomic
          factors.
        </p>

        <h3>What is Industry analysis?</h3>

        <p>
          Industry analysis is a tool that gives investors an A to Z insight
          into any industry. This encompasses insights about the level of
          competition in the industry, demand and supply situation, how easily
          new companies enter the industry etc.
        </p>

        <h3>What is Company Analysis?</h3>

        <p>
          Company analysis contains an evaluation & examination of a company,
          its financial health & prospects, management strategy, marketing
          activities, its strengths & weaknesses.
        </p>

        <p>
          The factors considered in company analysis include financial
          performance, market positioning, industry trends, management
          competence, competitive landscape, growth strategies, risk factors,
          stakeholder analysis, customer segmentation, regulatory factors, and
          the company's strategic initiatives.
        </p>

        <h3>What are the two types of fundamental analysis?</h3>

        <p>
          Quantitative and qualitative fundamental analysis are the two most
          prevalent forms of fundamental analysis that you can use to determine
          the intrinsic value of a stock to identify whether it is undervalued
          or overvalued in the market.
        </p>

        <h3>What is fundamental analysis vs technical analysis?</h3>

        <p>
          Fundamental analysis focuses on financial statements and economic
          indicators to assess an asset's intrinsic value, making it more
          suitable for long-term investment decisions. Alternatively, technical
          analysis examines share price movements and trends to identify
          investment opportunities in the short-term perspective.
        </p>

        <h3>What are the five steps of fundamental analysis?</h3>
        <b>How to do fundamental analysis.</b>
        <ul>
          <li>Step 1: Economic and Market Analysis.</li>
          <li>Step 2: Analysis of Financial Statements.</li>
          <li>Step 3: Forecasting relevant payoffs.</li>
          <li>Step 4: Formulating a security value.</li>
          <li>Step 5: Making a recommendation.</li>
        </ul>

        <h3>Who uses fundamental analysis?</h3>

        <p>
          Investors have traditionally used fundamental analysis for longer-term
          trades, relying on metrics like earnings per share (EPS),
          price-to-earnings (P/E) ratio, P/E growth, and dividend yield.
        </p>

        <h3>Why fundamental analysis is best?</h3>

        <p>
          Fundamental analysis takes into account a range of factors that can
          impact a company's value, including its financial statements,
          management team, industry trends, and macroeconomic conditions. The
          goal is to assess the overall health of the company and its ability to
          generate future cash flows. Investor and great icon like Warren Buffet
          uses this method only to invest in stock market.
        </p>

        <h3>Is fundamental analysis a strategy?</h3>

        <p>
          Fundamental analysis is an assessment strategy that focuses on the
          intrinsic value of an asset.
        </p>

        <h3>What are the Basics of Fundamental Analysis?</h3>

        <p>
          Before conducting fundamental analysis of a stock, you need to
          consider a few basic factors. These factors are –
        </p>

        <ul>
          <li>Company’s structure and revenue</li>
          <li>Company’s profits over the years</li>
          <li>Revenue growth over the years</li>
          <li>Company’s debt</li>
          <li>Corporate governance</li>
          <li>Rate of turnover</li>
        </ul>

        <p>
          Analysts look at these six factors while conducting a fundamental
          analysis of any security and determine its intrinsic value.
        </p>

        <h3>How to Do Fundamental Analysis of a Stock?</h3>

        <p>
          Here are some necessary steps to start a fundamental analysis of a
          company.
        </p>

        <ul>
          <li>Understand the company, its operations, business model, etc.</li>
          <li>Use the financial ratios for initial screening.</li>
          <li>Closely study the financial reports of the company.</li>
          <li>Find the company’s competitors/rivals and study them.</li>
          <li>Check the company’s debt and compare it with rivals.</li>
          <li>Analyze the company’s prospects.</li>
        </ul>

        <h3> What are the components of fundamental analysis?</h3>

        <p>
          A few elements of quantitative fundamental analysis are EPS, P/E
          ratio, P/B ratio, Debt/Equity ratio and RoE ratio. These are among the
          few fundamental indicators that help you understand deeper about the
          company/stock.
        </p>

        <ul>
          <li>
            Earning Per Share is called EPS. This is a measure of profitability.
          </li>

          <li>
            EPS = Net Profit of The Company divided Number of Outstanding Shares
          </li>

          <li>
            Price to Earnings Ratio is called P/E ratio. This is a measure of
            valuation.
          </li>

          <li>P/E = Price of Stock divided Earnings Per Share</li>

          <li>
            Price to Book ratio is called P/B ratio. This is a measure of
            valuation for banking and financial companies.
          </li>

          <li>P/B = Price of Stock divided Book Value of Stock/Company</li>

          <li>
            Debt to Equity ratio is called D/E. This is a measure of
            indebtedness.
          </li>

          <li>
            Debt to Equity Ratio = Total Liabilities of the company divided
            Total shareholder’s equity
          </li>

          <li>
            Return on Equity Ratio is called RoE. It is a profit measure that
            can be generated with the money that has been invested by its
            shareholders.
          </li>

          <li>
            Return on equity = Net Income of company divided by Shareholder’s
            equity
          </li>
        </ul>

        <h3>What are Financial Ratios?</h3>

        <p>
          Financial ratios help you interpret any company’s finances’ raw data
          to get actionable inputs on its overall performance. You can source
          the ratios from a company’s financial statements to evaluate its
          valuation, rates of return, profitability, growth, margins, leverage,
          liquidity, and more.
        </p>

        <p>
          In simple words, a financial ratio involves taking one number from a
          company’s financial statements and dividing it by another. The
          resulting answer gives you a metric that you can use to compare
          companies to evaluate investment opportunities.
        </p>

        <h3>What are the types of Financial Ratios?</h3>

        <p>
          Different financial ratios offer different aspects of a company’s
          financial health, from how it can cover its debt to how it utilizes
          its assets. A single ratio may not cover the company’s entire
          performance unless viewed as part of a whole.
        </p>

        <p>
          These ratios are time-sensitive as they assess data that changes over
          time. So you can use these ratios to your benefit by comparing them
          from different periods to get a general idea of a company’s growth or
          regression over time.
        </p>

        <p>Types of Ratio Analysis:</p>

        <p>
          The various kinds of financial ratios available may be broadly grouped
          into the following six, based on the sets of data they provide:
        </p>

        <b>1. Liquidity Ratios</b>

        <p>
          Liquidity ratios tell a company’s ability to pay its debt and other
          liabilities. By analyzing liquidity ratios, you can gauge if the
          company has assets to cover long-term obligations or the cash flow is
          enough to cover overall expenses. If the answers are positive, you may
          say the company has adequate liquidity, or else there may be problems.
        </p>

        <p>
          These liquidity ratios are notably more critical with small-cap and
          penny stocks. Newer and smaller companies often have difficulties
          covering their expenses before they stabilize.
        </p>

        <b>Liquidity ratios are</b>

        <ul>
          <li>
            Operating Cash Flow Margin = Cash from operating activities / Sales
            Revenue
            <br />
            The operating cash flow margin indicates how efficiently a company
            generates cash flow from sales and indicates earnings quality.
          </li>
          <li>
            Cash Ratio = (Cash + Cash Equivalents) / Total Liabilities
            <br />
            The cash ratio will give you the amount of cash a company has
            compared to its total assets.
          </li>
          <li>
            Quick Ratio = (Current Assets – Inventory) / Current Liabilities
            <br />
            The quick ratio, aka acid-test ratio, will assess a company’s
            marketable securities, receivables, and cash against its
            liabilities. This gives you an idea about the company’s ability to
            pay for its current obligations.
          </li>
          <li>
            Current Ratio = Current Assets / Current Liabilities
            <br />
            The current ratio will give you an idea about how well the company
            can meet its financial obligations in the coming 12 months
          </li>
        </ul>

        <b>2. Solvency Ratios</b>

        <p>
          It is also called financial leverage ratios. Solvency ratios compare a
          company's debt levels with its assets, equity, and earnings, to
          evaluate the likelihood of a company staying afloat over the long
          haul, by paying off its long-term debt as well as the interest on its
          debt. Examples of solvency ratios include: debt-equity ratios,
          debt-assets ratios, and interest coverage ratios.
        </p>

        <p>Leverage ratios are</p>

        <ul>
          <li>
            Debt Ratio = Total Debt / Total Assets
            <br />
            The debt ratio compares a company’s debt to its assets as a whole.
          </li>
          <li>
            Interest Coverage Ratio = Earnings Before Interest and Tax /
            Interest Expense
            <br />
            The interest coverage ratio gives insights into a company’s ability
            to handle the interest payments on its debts.
          </li>
          <li>
            Debt to Equity Ratios = Total Liabilities / Total Shareholders’
            Equity
            <br />A debt-to-equity ratio compares a company’s overall debt to
            its investor supplied capital.
          </li>
        </ul>

        <b>3. Profitability Ratios</b>

        <p>
          Profitability ratios tell us how well a company can generate profits
          from its operations. Profit margins like Net profit margin (NPM),
          Operating profit margin (OPM), Gross profit margin (GPM), return on
          assets (ROA), return on equity (ROE), return on capital employed
          (ROCE) etc. It is also called performance ratios.
        </p>

        <p>Profitability ratios are</p>

        <ul>
          <li>
            Return on Equity = Net Income / Shareholders’ Equity
            <br />
            ROE is also the return on net assets, as shareholders’ equity is the
            total assets minus debt.
          </li>
          <li>
            Return on Assets = Net Income / Total Assets
            <br />
            ROA measures the efficiency of a company in generating earnings from
            its assets.
          </li>
          <li>
            Gross Profit Margin = (Revenue – Cost of Goods Sold) / Revenue
            <br />A gross profit margin ratio will tell you the relation between
            the company’s gross sales and profits.
          </li>
          <li>
            Operating Profit Margin = Operating Profit / Revenue
            <br />
            Operating profit margin indicates a company’s profit margin before
            interest payments and taxes.
          </li>
        </ul>

        <p>
          Net Profit Margin = Net Profit / Revenue
          <br />
          Net profit margin indicates a company’s net margins. A high net profit
          margin is a good indication of an efficient business
        </p>

        <b>4. Efficiency Ratios</b>

        <p>
          Efficiency ratios are also called activity ratios. Efficiency ratios
          evaluate how efficiently a company uses its assets and liabilities to
          generate sales and maximize profits. Key efficiency ratios include:
          turnover ratio, inventory turnover ratio, and days' sales in
          inventory.
        </p>

        <b>Commonly used activity ratios are:</b>

        <ul>
          <li>
            Inventory turnover ratio = Net Sales / Average Inventory at Selling
            Price
            <br />
            This ratio can indicate how efficient the company is at managing its
            inventory. A high ratio implies either strong sales or insufficient
            inventory.
          </li>
          <li>
            Receivables turnover = Net Sales / Average accounts receivable
            <br />
            Receivables turnover indicates how quickly net sales are turned into
            cash.
          </li>
          <li>
            Payables turnover = Total supply purchase / Average Accounts Payable
            <br />
            Accounts payable turnover ratio is a short-term liquidity measure
            that shows how many times a company pays off its accounts payable
            during a period, and indicates short term liquidity.
          </li>
          <li>
            Fixed asset turnover ratio = Net Sales / Average Fixed Assets
            <br />
            Fixed asset turnover measures how efficient a company is in
            generating sales from its fixed assets – property, plant, and
            equipment.
          </li>
          <li>
            Total asset turnover ratio = Net Sales / Average Total Assets
            <br />
            Fixed asset turnover measures how efficiently a company is using its
            assets to generate sales
          </li>
        </ul>

        <b>5. Coverage Ratios</b>

        <p>
          Coverage ratios measure a company's ability to make the interest
          payments and other obligations associated with its debts. Examples
          include the times interest earned ratio and the debt-service coverage
          ratio.
        </p>

        <b>6. Market Prospect Ratios (Valuation Ratios)</b>

        <p>
          These are the most commonly used ratios in fundamental analysis. They
          include dividend yield, P/E ratio, earnings per share (EPS), and
          dividend payout ratio. Investors use these metrics to predict earnings
          and future performance.
        </p>

        <p>
          For example, if the average P/E ratio of all companies in the Nifty 50
          index is 20, and the majority of companies have P/Es between 15 and
          25, a stock with a P/E ratio of seven would be considered undervalued.
          In contrast, one with a P/E ratio of 50 would be considered
          overvalued. The former may trend upwards in the future, while the
          latter may trend downwards until each aligns with its intrinsic value.
        </p>

        <p>
          Valuation ratios generally rely on a company’s current share price and
          reveal whether the stock is an attractive investment option at the
          time. You can also call these ratios are market ratios as they examine
          a company’s attractiveness in the stock market.
        </p>

        <b>Common valuation ratios are:</b>

        <ul>
          <li>
            Price to Earnings Ratio (P/E) = Price per share / Earnings per share
            <br />
            P/E is one of the most commonly used financial ratios among
            investors to determine whether the company is undervalued or
            overvalued. The ratio indicates what the market is willing to pay
            today for a stock based on its past or future earnings.
          </li>
          <li>
            Price/Cash Flow (P/CF) = Share Price / Operating Cash Flow per Share
            <br />
            This ratio indicates a company’s stock price relative to the cash
            flow the company is generating. The advantage of P/CF ratio is that
            it is tough to manipulate for a company. While companies can change
            revenue and earnings through accounting practices, cash flow is
            relatively immune from it.
          </li>
          <li>
            PEG Ratio = Price to Earnings / Growth Rate
            <br />
            The PEG ratio is a valuation metric for determining the relative
            trade-off between the stock price, earnings per share, and a
            company’s expected growth. It makes it easier to compare high growth
            companies that tend to have a high P/E ratio to mature companies
            that have a lower P/E. It is thus a better indicator of the stock’s
            true value.
          </li>
        </ul>

        <p>
          Price to Sales Ratio (P/S) = Market Capitalization/Total Revenue
          <br />A P/S ratio compares a company’s market capitalization against
          its sales for the last 12 months. It is a measure of the value
          investors are receiving from the company’s stock by indicating how
          much they are paying for shares per dollar of the company’s overall
          sales.
        </p>
      </div>
    </>
  );
}
